<template>
  <div class="container-fluid">
    <div class="contents booking">
      <search />
      <b-form class="row row-cols-1 row-cols-sm-2 row-cols-md-auto g-2 mb-4">
        <div class="col">
          <select v-model="searchData.roompage">
            <template v-for="(rno, index) in roomsearchlist">
              <option
                :value="rno.num"
                :key="index + 'r'"
                v-if="parseInt(Math.ceil(roomcnt / 5)) >= rno.num"
              >
                {{ rno.pagenum }}
              </option>
            </template>
          </select>
        </div>
        <input type="hidden" v-model="searchData.roomsno" />
        <input type="hidden" v-model="searchData.roomeno" />

        <div class="col">
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              name="searchdate"
              v-model="searchData.searchdate"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="button"
              @click="searchDateChange"
            ></button>
          </div>
        </div>
      </b-form>

      <b-table-simple small bordered hover sticky-header responsive>
        <b-thead>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.date") }}</b-th>
            <template v-for="(item, idx1) in roommainlist">
              <b-th
                v-if="roomcnt >= idx1 + searchData.roomsno"
                v-bind:key="idx1"
                class="text-capitalize"
              >
                {{
                  roomlist.find((v) => v.roomnum == idx1 + searchData.roomsno)
                    .roomname
                }}
              </b-th>
              <b-th class="unavailable" v-else v-bind:key="idx1">
                -
                <!-- {{ idx1 + roomsno }}-->
              </b-th>
            </template>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, idx) in items.times" :key="idx">
            <b-td sticky-column>{{ item }}</b-td>
            <b-td
              v-if="roomcnt >= searchData.roomsno"
              @click="modalOpen(0 + searchData.roomsno, idx, items.room1[idx])"
            >
              <div v-html="displayInBox(items.room1[idx])"></div>
            </b-td>
            <b-td class="unavailable" v-else>
              <div v-html="displayInBoxnull()"></div>
            </b-td>

            <b-td
              v-if="roomcnt >= 1 + searchData.roomsno"
              @click="modalOpen(1 + searchData.roomsno, idx, items.room2[idx])"
            >
              <div v-html="displayInBox(items.room2[idx])"></div>
            </b-td>
            <b-td class="unavailable" v-else>
              <div v-html="displayInBoxnull()"></div>
            </b-td>

            <b-td
              v-if="roomcnt >= 2 + searchData.roomsno"
              @click="modalOpen(2 + searchData.roomsno, idx, items.room3[idx])"
            >
              <div v-html="displayInBox(items.room3[idx])"></div>
            </b-td>
            <b-td class="unavailable" v-else>
              <div v-html="displayInBoxnull()"></div>
            </b-td>

            <b-td
              v-if="roomcnt >= 3 + searchData.roomsno"
              @click="modalOpen(3 + searchData.roomsno, idx, items.room4[idx])"
            >
              <div v-html="displayInBox(items.room4[idx])"></div>
            </b-td>
            <b-td class="unavailable" v-else>
              <div v-html="displayInBoxnull()"></div>
            </b-td>

            <b-td
              v-if="roomcnt >= 4 + searchData.roomsno"
              @click="modalOpen(4 + searchData.roomsno, idx, items.room5[idx])"
            >
              <div v-html="displayInBox(items.room5[idx])"></div>
            </b-td>
            <b-td class="unavailable" v-else>
              <div v-html="displayInBoxnull()"></div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.booking.booking_write')"
          @click="bookingRev"
          >{{ $t("button.booking.booking_write") }}</b-button
        >
      </div>
    </div>

    <b-modal
      id="modal-booking-day"
      ref="modal-booking-day"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("title.setting.booking") }}
        </h5>
        <button
          type="button"
          class="btn-close"
          @click="$refs['modal-booking-day'].hide()"
        ></button>
      </template>

      <div class="row g-0 table-type header-col p-keep">
        <div class="col-sm-4">
          {{ $t("title.booking.room_name") }}
        </div>
        <div class="col-sm-8">
          <select class="" v-model="modalObj.roomno">
            <template v-for="(rno, index) in roomlist">
              <option :value="rno.roomnum" :key="index + 'r'">
                {{ rno.roomname }}
              </option>
            </template>
          </select>
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.date") }}
        </div>
        <div class="col-sm-8">
          <div class="row row-cols-2 row-cols-lg-3 g-2">
            <div class="col-12">
              <input
                type="date"
                class="form-control-lg"
                v-model="bookingDate"
              />
            </div>
            <div class="col-6">
              <select v-model="bookingStime">
                <option v-for="(time, idx) in option.starttimes" :key="idx">
                  {{ time }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <select v-model="bookingEtime">
                <option v-for="(time, idx) in option.endtimes" :key="idx">
                  {{ time }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.memo") }}
        </div>
        <div class="col-sm-8">
          <textarea v-model="modalObj.memo" cols="30" rows="10"></textarea>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="cancel"
          @click="cancel()"
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="delete"
          @click="bookinDelete"
          >{{ $t("button.common.delete") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          aria-label="save"
          @click="bookinSave"
          >{{ $t("button.common.save") }}</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Search from "./Search";
import commonDatePicker from "@/components/common/datepicker/Picker";
import { utils } from "@/mixin/utils";
import "@/filter/common";
import ax from "@/api/booking";
import _ from "lodash";

export default {
  name: "BookingDay",
  components: {
    Search,
  },
  mixins: [utils],
  data() {
    return {
      // 초기화 목적
      defaultItems: {
        times: [
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        room1: [],
        room2: [],
        room3: [],
        room4: [],
        room5: [],
      },
      items: {
        times: [
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        room1: [], // times idx와 동일하게 구성하고 booking list의 값을 넣어서 동작시킴
        room2: [],
        room3: [],
        room4: [],
        room5: [],
      },
      option: {
        starttimes: [
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        endtimes: [
          "05:59",
          "06:59",
          "07:59",
          "08:59",
          "09:59",
          "10:59",
          "11:59",
          "12:59",
          "13:59",
          "14:59",
          "15:59",
          "16:59",
          "17:59",
          "18:59",
          "19:59",
          "20:59",
          "21:59",
          "22:59",
          "23:59",
        ],
      },
      searchData: {
        searchdate:
          this.$store.state.searchData.searchdate ||
          this.$dayjs(new Date()).format("YYYY-MM-DD"),
        // pageno: this.$route.query.pageno || 1,
        // pagesize: this.$route.query.pagesize || 1000,
        roomsno:
          this.$route.query.roomsno ||
          this.$store.state.searchData.searchdate ||
          1,
        roomeno:
          this.$route.query.roomeno ||
          this.$store.state.searchData.searchdate ||
          5,
        roompage: 1,
      },
      // searchdate: this.$dayjs(new Date()).format('YYYY-MM-DD'),

      roommainlist: [1, 2, 3, 4, 5],
      roomsearchlist: [
        { num: 1, pagenum: "1-5" },
        { num: 2, pagenum: "6-10" },
        { num: 3, pagenum: "11-15" },
        { num: 4, pagenum: "16-20" },
        { num: 5, pagenum: "21-26" },
        { num: 6, pagenum: "26-30" },
      ],
      roomcnt: 0,
      roomlist: [],
      bookingDate: this.$dayjs(new Date()).format("YYYY-MM-DD"),
      bookingStime: this.$dayjs(new Date()).format("HH:00"),
      bookingEtime: this.$dayjs(new Date()).format("HH:59"),
      modalObj: {
        bookingno: null,
        roomno: 1,
        starttime: null,
        endtime: null,
        memo: null,
      },
    };
  },
  watch: {
    "searchData.searchdate": function () {
      this.init();
    },
    "searchData.roompage": function () {
      this.init();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.get_roomlist();

      this.searchData.roomsno = 5 * (this.searchData.roompage - 1) + 1;
      this.searchData.roomeno = 5 * (this.searchData.roompage - 1) + 5;

      // alert(this.roompage);
      ax.bookingList(this.searchData, (data) => {
        if (data) {
          this.items.times.push("00:00");
          // this.roomsno = 1;
          // this.roomeno = 5;
          for (let idx in this.items.times) {
            this.items.room1[idx] = {};
            this.items.room2[idx] = {};
            this.items.room3[idx] = {};
            this.items.room4[idx] = {};
            this.items.room5[idx] = {};

            // 날짜 만들기
            let inTime =
              this.searchData.searchdate + " " + this.items.times[idx] + ":00";
            // 재구성하기

            for (let i = 0; i < data.bookinglist.length; i++) {
              if (!data.bookinglist[i].roomno) continue;

              if (
                this.$dayjs(inTime).isBetween(
                  data.bookinglist[i].timezone_starttime,
                  this.$dayjs(data.bookinglist[i].timezone_endtime).add(
                    -1,
                    "s"
                  ),
                  "minute",
                  "[]"
                )
              ) {
                // alert(parseInt(data.bookinglist[i].starttime));
                let reMake = {
                  roomno: data.bookinglist[i].roomno,
                  starttime: data.bookinglist[i].timezone_starttime,
                  endtime: data.bookinglist[i].timezone_endtime,
                  memo: data.bookinglist[i].memo,
                  bookingno: data.bookinglist[i].bookingno,
                };
                // 각 room에 데이터 넣기
                // alert(Math.ceil(parseInt(data.bookinglist[i].roomno % 5)));

                switch (Math.ceil(parseInt(data.bookinglist[i].roomno % 5))) {
                  case 1:
                    this.items.room1[idx] = reMake;
                    // alert(data.bookinglist[i].roomno);
                    break;
                  case 2:
                    this.items.room2[idx] = reMake;
                    break;
                  case 3:
                    this.items.room3[idx] = reMake;
                    break;
                  case 4:
                    this.items.room4[idx] = reMake;
                    break;
                  case 5:
                    this.items.room5[idx] = reMake;
                    break;
                }
              }
            }
          }
          this.items.times = _.cloneDeep(this.defaultItems.times); // list display내용 갱신 위해 렌더링 다시 시킴
        } else {
          this.items = _.cloneDeep(this.defaultItems);
        }

        // this.roomsno = (5 * (this.params.pageno - 1));
        // this.get_roomlist();
      });
    },
    searchDateChange() {
      // this.$router.push({ query: { searchdate: v} }).catch(() => {})
      this.init();
    },
    searchRoomChange2(event) {
      // this.params.pageno = event.target.value;
      this.searchdate = this.searchData.searchdate;
      this.roomsno = 5 * (event.target.value - 1) + 1;
      this.roomeno = 5 * (event.target.value - 1) + 5;
      // this.$router.push({ query: { searchdate: this.searchdate, roomsno: this.roomsno, roomeno: this.roomeno } }).catch(() => {})
      this.init();
    },
    get_roomlist() {
      ax.get_roomlist((data) => {
        // console.log(data);
        // alert(data.roomlistcnt);
        if (data.code === 200) {
          this.roomcnt = data.roomlistcnt;
          this.roomlist = [];
          this.roomlist = data.roomlist;
        } else {
          alert(data.message);
        }
      });
    },
    // 내부 꾸미기
    displayInBox(o) {
      if (o) {
        if (o.starttime) {
          if (o.memo != null && o.memo.length > 12) {
            o.memos = o.memo.substr(0, 10) + "..";
          } else {
            o.memos = o.memo;
          }
          let text = this.$dayjs(o.endtime).format("HH:ss");
          return (
            "" +
            this.$dayjs(o.starttime).format("HH:ss") +
            "~" +
            text +
            "<br/>" +
            o.memos
          );
        } else {
          return "&nbsp;";
        }
      }
    },
    // 내부 꾸미기
    displayInBoxnull() {
      return this.$i18n.t("text.common.unavailable");
    },
    // div 배경 처리
    bookingClass(o) {
      if (o) {
        if (o.starttime) {
          return true;
        }
      }
    },
    modalOpen(roomno, idx, o) {
      if (o && !this.isEmpty(o)) {
        this.modalObj = o;
        this.bookingDate = this.$dayjs(o.starttime).format("YYYY-MM-DD");
        this.bookingStime = this.$dayjs(o.starttime).format("HH:00");
        this.bookingEtime = this.$dayjs(o.endtime).format("HH:59");

        // if (this.bookingEtime == "00:00") this.bookingEtime = "24:00";
      } else {
        let etimeIdx =
          idx === this.items.times.length
            ? this.items.times[this.items.times.length - 1] - 1
            : idx;
        if (this.searchData.searchdate) {
          this.bookingDate = this.searchData.searchdate;
        } else {
          this.bookingDate = this.$dayjs(new Date()).format("YYYY-MM-DD");
        }
        this.modalObj.roomno = roomno;
        this.modalObj.bookingno = null;
        this.bookingStime = this.option.starttimes[idx];
        this.bookingEtime = this.option.endtimes[etimeIdx];

        // alert(this.items.times[etimeIdx])
        this.modalObj.memo = null;
      }
      //this.$refs["modal-booking-day"].modalOuterStyle.zIndex = 9999;
      this.$refs["modal-booking-day"].show();
    },
    bookingRev() {
      if (this.searchData.searchdate) {
        this.bookingDate = this.searchData.searchdate;
      } else {
        this.bookingDate = this.$dayjs(new Date()).format("YYYY-MM-DD");
      }
      this.bookingStime = this.$dayjs(new Date()).format("HH:00");
      this.bookingEtime = this.$dayjs(new Date())
        .add(1, "hour")
        .format("HH:59");

      this.modalObj.roomno = 1;
      this.modalObj.bookingno = null;
      this.modalObj.starttime =
        this.bookingDate + " " + this.bookingStime + ":00";
      this.modalObj.endtime =
        this.bookingDate + " " + this.bookingEtime + ":59";
      this.modalObj.memo = null;
      this.$refs["modal-booking-day"].show();
    },
    bookinSave() {
      this.modalObj.starttime =
        this.bookingDate + " " + this.bookingStime + ":00";
      this.modalObj.endtime =
        this.bookingDate + " " + this.bookingEtime + ":59";
      if (this.modalObj.bookingno) {
        ax.bookingModify(this.modalObj, (flag, data) => {
          if (flag) {
            this.$notify({
              group: "info",
              type: "warn",
              title: "Notice",
              text: this.$i18n.t("text.booking.booking_has_been_modified"),
            });
          }
          this.init();
          this.$refs["modal-booking-day"].hide();
        });
      } else {
        delete this.modalObj["bookingno"];
        ax.bookingInsert(this.modalObj, (flag, data) => {
          if (flag) {
            this.$notify({
              group: "info",
              type: "warn",
              title: "Notice",
              text: this.$i18n.t("text.booking.successfully_booked"),
            });
          }
          this.init();
          this.$refs["modal-booking-day"].hide();
        });
      }
    },
    bookinDelete() {
      ax.bookingDelete(this.modalObj.bookingno, (flag, data) => {
        if (flag) {
          this.$notify({
            group: "info",
            type: "warn",
            title: "Notice",
            text: this.$i18n.t("text.booking.successfully_booked"),
          });
        }
        this.init();
        this.$refs["modal-booking-day"].hide();
      });
    },
  },
};
</script>
